"use client";

import { useEffect } from "react";
import { getDeviceId } from "./deviceId";
import { getClientTimezone } from "./TimezoneInitializer";

const AppInitializer = () => {
    useEffect(() => {
        // ✅ runs only in browser
        getClientTimezone();
        getDeviceId();
    }, []);

    return null;
};

export default AppInitializer;